import CarEntity, { TransmissionCar } from "../../../../../domain/entities/CarEntity";
import OrderByEntity from "../../../../../domain/entities/OrderByEntity";
import CarImplDto from "../../../../dto/impl/CarImplDto";
import HostApi from "../../../../settings/HostApi";

const mapTransmission = (t: TransmissionCar): number | "" =>
    t == TransmissionCar.AUTOMATIC ? 1 : t == TransmissionCar.MANUAL ? 0 : "";

const SearchCarApiImpl = async (
    page: number,
    search: string,
    brand: string | string[] | undefined,
    modelId: string | string[] | undefined,
    year: string | undefined,
    price: { min: number; max: number } | undefined,
    type: string | string[] | undefined,
    transmission: TransmissionCar | TransmissionCar[] | undefined,
    tag: string | string[] | undefined,
    km: { min: number; max: number } | undefined,
    fuelId: string | string[] | undefined,
    colorId: string | string[] | undefined,
    plateNumber: string | string[] | undefined,
    orderBy: OrderByEntity | undefined,
    warranty: boolean,
    traction: string | string[] | undefined,
    sede: string | string[] | undefined,
): Promise<{ cars: CarEntity[]; maxPages: number; count?: any }> => {
    try {
        const relativeUrl = `/v2/filter-cars/?page=${page}`;

        const transmissionValue = Array.isArray(transmission)
            ? transmission.map(mapTransmission).filter((v) => v !== "")
            : transmission != null
              ? mapTransmission(transmission)
              : "";

        const body = {
            brand: brand,
            model: modelId,
            tag: tag,
            price_from: price?.min ?? undefined,
            price_to: price?.max ?? undefined,
            year_from: year,
            year_to: year,
            mileage_from: km?.min ?? undefined,
            mileage_to: km?.max ?? undefined,
            body_type: type,
            colors: colorId ? (Array.isArray(colorId) ? colorId : [colorId]) : [],
            fuel_type: fuelId,
            transmission: transmissionValue,
            search_word: search,
            plate: plateNumber
                ? Array.isArray(plateNumber)
                    ? plateNumber.map(Number)
                    : [Number(plateNumber)]
                : undefined,
            orderBy: orderBy?.value != undefined ? (orderBy.value?.desc ? "desc" : "asc") : undefined,
            warranty: orderBy?.value?.warranty,
            traction: traction,
            sedes: sede,
        };

        const response = await HostApi.post(relativeUrl, body);

        return {
            cars: response.results
                .map((car: any) => CarImplDto.fromJson(car))
                .filter((car: CarEntity) => car.id != "19"),
            maxPages: response.num_pages,
            count: response.count,
        };
    } catch (error) {
        return {
            cars: [],
            maxPages: 0,
            count: 0,
        };
    }
};

export default SearchCarApiImpl;
